import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    images: [],
    attn: [],
    models: [],
    loadingImages: false,
    coloredCaption: false,
    noResult: false,
  },
  mutations: {
    fetchImages(state, payload) {
      // state.images = [];
      // for (let i = 0; i < payload; i++) {
      //   state.images.push('https://picsum.photos/200?image=' + Math.floor(Math.random() * 1084));
      // }
      // eslint-disable-next-line
      console.log(payload);
      state.loadingImages = true;
      axios.post('/search/' + payload.lang + '/' + payload.k, {
        headline: payload.headline,
        lead: payload.lead,
        caption: payload.caption,
        body: payload.body,
        entities: payload.entities,
        operator: payload.operator
      }).then(response => {
        // eslint-disable-next-line
        console.log(response);
        state.images = response.data.image_id;
        if (state.images.length == 0) {
          state.noResult = true;
        }
        state.attn = [];
        state.coloredCaption = false;

        state.loadingImages = false;
      }).catch(err => {
        // eslint-disable-next-line
        console.error(err);
        state.loadingImages = false;
      })
    },
    removeImages(state) {
      state.images = [];
      state.attn = [];
      state.coloredCaption = false;
    },
    setNoResult(state, payload) {
      state.noResult = payload;
    }
  },
  actions: {
    fetchImages({
      commit
    }, payload) {
      commit('fetchImages', payload);
    },
    removeImages({
      commit
    }) {
      commit('removeImages');
    },
    setNoResult({
      commit
    }, payload) {
      commit('setNoResult', payload);
    }
  },
  getters: {
    images: state => {
      return state.images;
    },
    attn: state => {
      return state.attn;
    },
    coloredCaption: state => {
      return state.coloredCaption;
    },
    models: state => {
      return state.models;
    },
    loadingImages: state => {
      return state.loadingImages;
    },
    noResult: state => {
      return state.noResult;
    }
  }
})